/**
 * Final shape returned by `userAPIClient.getCookieUser()`.
 * - Logged‑in → `CookieUser`
 * - Not logged‑in (401) → `null`
 */
export type GetCookieUserResponse = {
  id: number;
  username: string;
  email: string;
  display_name: string;
  roles: string[];
  cookie_source: string;
} | null;
